import { createBooleanSelectComponent } from "../factories";
import { BooleanSelectProps } from "../types";

// Active Status Select Component (string-based)
export const ActiveStatusSelect = createBooleanSelectComponent(
  "active",
  "inactive",
  "Active",
  "Inactive",
  "Select status..."
);

// Boolean Active Status Select Component (boolean-based)
export function BooleanActiveStatusSelect({
  value,
  onValueChange,
  placeholder = "Select status...",
  disabled = false,
  error = false,
  required = false,
}: BooleanSelectProps) {
  const handleValueChange = (newValue: string) => {
    onValueChange(newValue === "active");
  };

  return (
    <ActiveStatusSelect
      value={value ? "active" : "inactive"}
      onValueChange={handleValueChange}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      required={required}
    />
  );
}
